/**
 * Battery status helpers (OI-084).
 *
 * GET /batteries sends two independent values per battery:
 * - `status` — the lifecycle as stored (the values below; the server may also hold e.g. damaged, which
 *   the page shows like an active battery);
 * - `battery_status` — cycle health computed by the server (BatteryHealthStatuses: cycles at or over
 *   the limit, or a retired battery, are critical; 80 % of the limit is a warning).
 * "replace" belongs to a different vocabulary (battery compliance) and never comes in battery_status.
 */

export const BATTERY_LIFECYCLE_STATUS = {
  ACTIVE: 'active',
  MAINTENANCE: 'maintenance',
  RETIRED: 'retired',
};

export const BATTERY_HEALTH_STATUS = {
  GOOD: 'good',
  WARNING: 'warning',
  CRITICAL: 'critical',
};

/**
 * Batteries due for replacement: critical health, except retired ones — the server reports a retired
 * battery as critical too, but it is already out of service. A critical battery in maintenance counts.
 */
export const countBatteriesNeedingReplacement = (batteries) =>
  batteries.filter(
    (b) => b.battery_status === BATTERY_HEALTH_STATUS.CRITICAL && b.status !== BATTERY_LIFECYCLE_STATUS.RETIRED,
  ).length;
